import { RootState } from "store/store";
import { EstadoRequisicao } from "store/types";

class ListaSelector {
    static readonly carregando = (it: RootState) => it.solicitacoes.estado === EstadoRequisicao.CARREGANDO;
    static readonly erros = (it: RootState) => it.solicitacoes.erros;

    static readonly elementos = (it: RootState) => it.solicitacoes.elementos;

    static readonly totalElementos = (it: RootState) => it.solicitacoes.totalElementos;

    static readonly paginacao = (it: RootState) => it.solicitacoes.pagina;

    static readonly isOcioso = (it: RootState) => it.solicitacoes.estado===EstadoRequisicao.OCIOSO;

    static readonly filtros = (it: RootState) => it.solicitacoes.filtros;

    static readonly ordem = (it: RootState) => it.solicitacoes.ordem;
}

export class SolicitacoesSelector {
    static readonly lista = ListaSelector;
}